module.exports = __webpack_public_path__ + "static/2front-graphic-design-3-149fb8ab157a7251dcdba4319dcb8e3f.png";